// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    indexerGetAddressesAddress (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressParentSubaccountNumberNumber (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetAssetPositions (params?: {}): Promise<Dict>;
    indexerGetAssetPositionsParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetCandlesPerpetualMarketsMarket (params?: {}): Promise<Dict>;
    indexerGetComplianceScreenAddress (params?: {}): Promise<Dict>;
    indexerGetFills (params?: {}): Promise<Dict>;
    indexerGetFillsParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetFundingPayments (params?: {}): Promise<Dict>;
    indexerGetFundingPaymentsParentSubaccount (params?: {}): Promise<Dict>;
    indexerGetHeight (params?: {}): Promise<Dict>;
    indexerGetHistoricalPnl (params?: {}): Promise<Dict>;
    indexerGetHistoricalPnlParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetHistoricalBlockTradingRewardsAddress (params?: {}): Promise<Dict>;
    indexerGetHistoricalFundingMarket (params?: {}): Promise<Dict>;
    indexerGetHistoricalTradingRewardAggregationsAddress (params?: {}): Promise<Dict>;
    indexerGetOrderbooksPerpetualMarketMarket (params?: {}): Promise<Dict>;
    indexerGetOrders (params?: {}): Promise<List>;
    indexerGetOrdersParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetOrdersOrderId (params?: {}): Promise<Dict>;
    indexerGetPerpetualMarkets (params?: {}): Promise<Dict>;
    indexerGetPerpetualPositions (params?: {}): Promise<Dict>;
    indexerGetPerpetualPositionsParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetScreen (params?: {}): Promise<Dict>;
    indexerGetSparklines (params?: {}): Promise<Dict>;
    indexerGetTime (params?: {}): Promise<Dict>;
    indexerGetTradesPerpetualMarketMarket (params?: {}): Promise<Dict>;
    indexerGetTransfers (params?: {}): Promise<Dict>;
    indexerGetTransfersBetween (params?: {}): Promise<Dict>;
    indexerGetTransfersParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetVaultV1MegavaultHistoricalPnl (params?: {}): Promise<Dict>;
    indexerGetVaultV1MegavaultPositions (params?: {}): Promise<Dict>;
    indexerGetVaultV1VaultsHistoricalPnl (params?: {}): Promise<Dict>;
    indexerGetPerpetualMarketSparklines (params?: {}): Promise<Dict>;
    indexerGetPerpetualMarketsTicker (params?: {}): Promise<Dict>;
    indexerGetPerpetualMarketsTickerOrderbook (params?: {}): Promise<Dict>;
    indexerGetTradesPerpetualMarketTicker (params?: {}): Promise<Dict>;
    indexerGetHistoricalFundingTicker (params?: {}): Promise<Dict>;
    indexerGetCandlesTickerResolution (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressSubaccounts (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberAssetPositions (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberPerpetualPositions (params?: {}): Promise<Dict>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberOrders (params?: {}): Promise<Dict>;
    indexerGetFillsParentSubaccount (params?: {}): Promise<Dict>;
    indexerGetHistoricalPnlParentSubaccount (params?: {}): Promise<Dict>;
    indexerGetPnl (params?: {}): Promise<Dict>;
    indexerGetPnlParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerGetTradeHistory (params?: {}): Promise<Dict>;
    indexerGetTradeHistoryParentSubaccountNumber (params?: {}): Promise<Dict>;
    indexerPostTurnkeySignin (params?: {}): Promise<Dict>;
    indexerPostTurnkeyUploadAddress (params?: {}): Promise<Dict>;
    nodeRpcGetAbciInfo (params?: {}): Promise<Dict>;
    nodeRpcGetBlock (params?: {}): Promise<Dict>;
    nodeRpcGetBroadcastTxAsync (params?: {}): Promise<Dict>;
    nodeRpcGetBroadcastTxSync (params?: {}): Promise<Dict>;
    nodeRpcGetTx (params?: {}): Promise<Dict>;
    nodeRestGetCosmosAuthV1beta1AccountInfoDydxAddress (params?: {}): Promise<Dict>;
    nodeRestPostCosmosTxV1beta1Encode (params?: {}): Promise<Dict>;
    nodeRestPostCosmosTxV1beta1Simulate (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
